import React from 'react';
import { useEmailInsight } from 'hooks/emailHistory/useEmailInsight';
import { AIInsightPanel } from './AIInsightPanel';
import { AIInsightSkeleton } from './AIInsightSkeleton';
import { AIInsightError } from './AIInsightError';

/**
 * @component AIInsight
 * @description Main orchestrator component for AI insights
 * @param {Object} props
 * @param {string} props.tab - Tab identifier ('campaigns', 'bulk-emails', 'individual', 'scheduled')
 * @param {Object} props.filters - Filter parameters from useEmailHistoryFilters
 * @returns {JSX.Element}
 */
export function AIInsight({ tab, filters }) {
  const { insight, isLoading, error, refetch } = useEmailInsight(tab, filters);

  if (isLoading) {
    return <AIInsightSkeleton />;
  }

  if (error) {
    return <AIInsightError error={error} onRetry={refetch} />;
  }

  if (insight) {
    return <AIInsightPanel insight={insight} />;
  }

  // Fallback (shouldn't normally reach here)
  return <AIInsightError error={{ code: 'GENERIC', message: 'Could not generate insight' }} onRetry={refetch} />;
}

